import Joi from "joi-browser";
import React from "react";
import { Offcanvas } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { getSettings } from "store/settings";
import { addAd, getTelegram, loadAds, updateAd } from "store/telegram";

//  Images
import closeIcon from "include/images/dark-close-icon.svg";

//  Components
import AlertError from "common/alert/alertError";
import AlertSuccess from "common/alert/alertSuccess";
import Form from "common/form/form";
import SelectSearch from "common/form/selectSearch";
import NextButton from "common/form/submitButton";

class AddFlyer extends Form {
  fileInputRef = React.createRef(null);
  blockTypeOptions = [
    { name: "Reward", value: "reward" },
    { name: "Interstitial", value: "interstitial" },
    { name: "Task", value: "task" },
  ];

  initState = {
    loading: false,
    data: {
      name: "",
      blockType: this.blockTypeOptions[0],
      blockId: "",

      reward: 0,
      displayOrder: null,
      status: null,
    },
    errors: {},
    edit: false,
  };
  state = { ...structuredClone(this.initState) };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.showModal !== prevProps.showModal) {
      this.clearData();
      if (this.props.showModal) {
        const data = { ...this.state.data };
        if (this.props.edit) {
          data.name = this.props.edit.name;
          data.blockType = this.blockTypeOptions?.find(({ value }) => value === this.props.edit.blockType);
          data.blockId = this.props.edit.blockId;
          data.reward = this.props.edit.reward;
          data.displayOrder = this.props.edit?.displayOrder;
          data.status =
            this.props.edit?.status === "active"
              ? { name: "Active", value: "active" }
              : { name: "Inactive", value: "inactive" };
        }
        if (this.props.edit?.displayOrder)
          data.displayOrder = { name: `${this.props.edit?.displayOrder}`, value: this.props.edit?.displayOrder };
        this.setState({
          data,
          edit: this.props.edit,
        });
      }
    }
  };
  handleResponse = (res) => {
    console.log(res);
    this.setState({ loading: false });
    if (res?.status === 200) {
      toast(<AlertSuccess message="Information Saved" />, { containerId: 1 });
      this.clearData();
      this.props.loadAds();
      this.props.toggleModal();
    } else {
      toast(<AlertError message={res.data && res.data.message} />, { containerId: 1 });
    }
  };
  doSubmit = (e) => {
    this.setState({ loading: true });
    const data = { ...this.state.data };
    const payLoad = {
      name: data.name,
      blockType: data.blockType?.value,
      blockId: data.blockId,
      reward: parseInt(data.reward),
      status: data.status?.value,
    };
    if (data?.displayOrder?.value) payLoad.displayOrder = data?.displayOrder?.value;

    if (this.props.edit) {
      this.props.updateAd(this.props.edit._id, payLoad, this.handleResponse);
    } else {
      this.props.addAd(payLoad, this.handleResponse);
    }
  };

  schema = {
    name: Joi.string().required(),
    blockType: Joi.object(),
    blockId: Joi.string().required(),
    reward: Joi.number().required(),
    status: Joi.object().required(),
    displayOrder: Joi.object().allow([{}, null]),
  };
  clearData = () => {
    this.setState({ ...this.initState });
  };

  onTypeChange = (e) => {
    const data = { ...this.state.data };
    const errors = { ...this.state.errors };
    data[e.target.name] = !data[e.target.name];
    delete errors[e.target.name];
    this.setState({ data, errors });
  };
  onChange = (e) => {
    const data = this.state.data;
    const errors = this.state.errors;
    data[e.name] = e.currentTarget;
    delete errors[e.name];

    this.setState({ data, errors });
  };
  render() {
    return (
      <Offcanvas
        className={"offcanvas offcanvas-end  custom-offcanvas-pannel "}
        show={this.props.showModal}
        onHide={this.props.toggleModal}
        id="rewardPannel"
        placement="right"
        name="rewardPannel"
        backdrop={true}
      >
        <Offcanvas.Header>
          <h5>{this.props.edit ? "Edit " : "Add a"} Ad</h5>
          <div
            className="btn_close pointer"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={this.props.toggleModal}
          >
            <img src={closeIcon} alt="" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-check-outer">
            <div className="new-form-group">
              <div className="row">{this.renderInput("name", "Name")}</div>
            </div>

            <div className="new-form-group">
              <label className="form-label">Block Type</label>
              <SelectSearch
                name="blockType"
                options={this.blockTypeOptions}
                label="Select Block Type"
                value={this.state.data.blockType}
                error={this.state.errors.blockType}
                onChange={this.onChange}
              />
            </div>
            <div className="new-form-group">
              <div className="row">{this.renderInput("blockId", "Block Id")}</div>
            </div>

            <div className="new-form-group">
              <div className="row">{this.renderInput("reward", "Reward (In Points)", "", "number")}</div>
            </div>

            <div className="new-form-group">
              <label className="form-label">Status</label>
              <SelectSearch
                name="status"
                options={[
                  {
                    name: "Active",
                    value: "active",
                  },
                  {
                    name: "Inactive",
                    value: "inactive",
                  },
                ]}
                label="Select Status"
                value={this.state.data.status}
                error={this.state.errors.status}
                onChange={this.onChange}
              />
            </div>
            <div className="new-form-group">
              <label className="form-label">Display Order</label>
              <SelectSearch
                name="displayOrder"
                options={[...Array(20).keys()].map((i) => ({ name: `${i + 1}`, value: i + 1 }))}
                label="Select Display Order"
                value={this.state.data.displayOrder}
                error={this.state.errors.displayOrder}
                onChange={this.onChange}
              />
            </div>
          </div>
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          <NextButton
            classData="btn btn-default btn-block h-100"
            label="Save"
            loading={this.state.loading || this.state.loadingImages}
            handleSubmit={this.handleSubmit}
          />
        </div>
      </Offcanvas>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadAds: (callback) => dispatch(loadAds(callback)),
  addAd: (data, callback) => dispatch(addAd(data, callback)),
  updateAd: (id, data, callback) => dispatch(updateAd(id, data, callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
  getSettings: getSettings(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddFlyer));
